module.exports = __webpack_public_path__ + "img/gle_gemlandtoken.faa96ff.png";